var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLogged)?_c('div',[_c('Navbar'),_c('div',{staticClass:"main-content"},[_c('TopBar'),_c('slide-y-up-transition',{attrs:{"mode":"out-in","origin":"center top"}},[_c('router-view')],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }